import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Gift Cheque History", -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "#"),
    /*#__PURE__*/_createVNode("th", null, "User ID"),
    /*#__PURE__*/_createVNode("th", null, "Product Description"),
    /*#__PURE__*/_createVNode("th", null, "Date"),
    /*#__PURE__*/_createVNode("th", null, "Ticket No."),
    /*#__PURE__*/_createVNode("th", null, "Released By"),
    /*#__PURE__*/_createVNode("th", null, "Released Date"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4" }, "Status")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("td", {
  colspan: "8",
  class: "text-center text-muted py-10"
}, "No gift cheque history found.", -1)
const _hoisted_11 = { class: "ps-4" }
const _hoisted_12 = { class: "text-muted fs-8" }
const _hoisted_13 = { class: "fw-semibold text-gray-800" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "fw-semibold text-gray-800 mb-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("option", {
  value: "x",
  selected: ""
}, "Please select an option", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", {
  value: "x",
  selected: ""
}, "Please select an option", -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "fw-semibold text-gray-800" }
const _hoisted_20 = { class: "text-muted fs-8" }
const _hoisted_21 = { class: "text-muted fs-8" }
const _hoisted_22 = { class: "fw-semibold text-gray-800" }
const _hoisted_23 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_24 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_25 = { class: "pe-4" }
const _hoisted_26 = {
  key: 0,
  class: "seq-badge seq-badge--success"
}
const _hoisted_27 = {
  key: 1,
  class: "seq-badge seq-badge--success"
}
const _hoisted_28 = {
  key: 2,
  class: "seq-badge seq-badge--success"
}
const _hoisted_29 = {
  key: 3,
  class: "seq-badge seq-badge--pending"
}
const _hoisted_30 = {
  key: 4,
  class: "seq-badge seq-badge--pending"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
          ]),
          _hoisted_4
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("table", _hoisted_7, [
            _hoisted_8,
            _createVNode("tbody", null, [
              (_ctx.list.length === 0)
                ? (_openBlock(), _createBlock("tr", _hoisted_9, [
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_11, [
                    _createVNode("span", _hoisted_12, _toDisplayString(index + 1), 1)
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_13, _toDisplayString(item.usid), 1)
                  ]),
                  (item.pcode == 'I2' && item.doneoptionsubmit != 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_14, [
                        _createVNode("div", _hoisted_15, _toDisplayString(item.pdesc), 1),
                        (_ctx.redeemOptions.length === 0)
                          ? (_openBlock(), _createBlock("select", {
                              key: 0,
                              class: "seq-period-filter__select mb-2",
                              onClick: ($event: any) => (_ctx.loadRedeemOptions(item.pcode))
                            }, [
                              _hoisted_16
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.redeemOptions.length !== 0)
                          ? _withDirectives((_openBlock(), _createBlock("select", {
                              key: 1,
                              class: "seq-period-filter__select mb-2",
                              "onUpdate:modelValue": ($event: any) => (_ctx.gc.options[index] = $event)
                            }, [
                              _hoisted_17,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.redeemOptions, (option, optionIndex) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: optionIndex,
                                  value: option.option_id
                                }, _toDisplayString(option.option_desc), 9, ["value"]))
                              }), 128))
                            ], 8, ["onUpdate:modelValue"])), [
                              [_vModelSelect, _ctx.gc.options[index]]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-seq-green btn-sm",
                          onClick: ($event: any) => (_ctx.submitGCOption(item.pcode, item.recid, index, item.pin1))
                        }, " Submit ", 8, ["onClick"])
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_18, [
                        _createVNode("div", _hoisted_19, _toDisplayString(item.pdesc), 1)
                      ])),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_20, _toDisplayString(item.dteStp), 1)
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_21, _toDisplayString(item.pin1), 1)
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_22, _toDisplayString(item.releasedBy), 1)
                  ]),
                  _createVNode("td", null, [
                    (item.releasedDte === 'Jan  1 1900 12:00AM')
                      ? (_openBlock(), _createBlock("div", _hoisted_23))
                      : (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(item.releasedDte), 1))
                  ]),
                  _createVNode("td", _hoisted_25, [
                    (item.releasedSts == 1)
                      ? (_openBlock(), _createBlock("span", _hoisted_26, "Released"))
                      : (item.releasedSts == 10)
                        ? (_openBlock(), _createBlock("span", _hoisted_27, "Claimed"))
                        : (item.releasedSts == 11)
                          ? (_openBlock(), _createBlock("span", _hoisted_28, "Verified"))
                          : (item.releasedSts == 99)
                            ? (_openBlock(), _createBlock("span", _hoisted_29, "Converted to Swatch"))
                            : (_openBlock(), _createBlock("span", _hoisted_30, "Pending"))
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}